// series-7 (bloque A cliente, #489, 24-sep-2026): EL PRECIO DE UNA OFERTA EN LA APP.
//
// En la app los paquetes y Pro cuestan lo que diga Apple (StoreKit), no la constante de la
// web: la oferta suma los precios de ESOS productos, leidos del catalogo que ya expone
// `lib/purchases.js` (`snapshot().products[clave]` con `price` y `currencyCode`, lo que
// su cabecera documenta para "los derivados") y los formatea con Intl.NumberFormat, igual
// que `PricingPage.js` (`dinero`). Si falta un producto o el catalogo no esta listo, NO hay
// cifra: jamas el precio de la web como respaldo (la regla de CreditPackModal).
//
// `purchases.js` es intocable y aqui solo se LEE. Tampoco se importa arriba: ese modulo
// trae `lib/api` (y con el `src/i18n`), y esta pieza la consume una tarjeta que montan el
// Panel y Pendientes; importarlo en el cuerpo tumbaria a las baterias que las montan sin
// doblar `lib/api`. Se pide al llamar, y solo en build de app: en web nunca se carga.
import React from 'react';
import { IS_APP_BUILD } from './buildTarget';

function compras() {
  return require('./purchases');
}

// pack_id del servidor -> clave del producto de Apple (APPLE_PRODUCT_IDS en purchases.js).
const CLAVE_DE_PAQUETE = { small: 'pack_small', large: 'pack_large' };
const CLAVE_DE_PRO = 'pro_monthly';

// La suma de los productos de la oferta, formateada; null si no se puede decir.
export function precioDeOfertaEnTienda(oferta, catalogo, idioma) {
  if (!oferta || !catalogo || catalogo.status !== 'ready') return null;
  const productos = catalogo.products || {};
  let total = 0;
  let moneda = null;
  let piezas = 0;
  const sumar = (clave, veces) => {
    const p = productos[clave];
    if (!p || typeof p.price !== 'number' || !Number.isFinite(p.price) || !p.currencyCode) return false;
    if (moneda && moneda !== p.currencyCode) return false;
    moneda = p.currencyCode;
    total += p.price * veces;
    piezas += 1;
    return true;
  };
  if (oferta.pro && !sumar(CLAVE_DE_PRO, 1)) return null;
  for (const pk of oferta.packs || []) {
    const clave = CLAVE_DE_PAQUETE[pk.pack_id];
    if (!clave || typeof pk.count !== 'number' || pk.count < 1) return null;
    if (!sumar(clave, pk.count)) return null;
  }
  if (!piezas) return null;
  const redondo = Math.round(total * 100) / 100;
  try {
    return new Intl.NumberFormat(idioma || undefined, { style: 'currency', currency: moneda }).format(redondo);
  } catch (e) {
    return `${redondo}`;
  }
}

// El catalogo de la tienda, vivo, mientras `activo`. En web siempre null (y sin cargar
// `purchases.js`). Se suscribe como CreditPackModal.js (subscribeProducts + loadProducts).
export function useCatalogoDeLaTienda(activo) {
  const [catalogo, setCatalogo] = React.useState(() => (IS_APP_BUILD && activo ? compras().snapshot() : null));
  React.useEffect(() => {
    if (!IS_APP_BUILD || !activo) return undefined;
    const p = compras();
    setCatalogo(p.snapshot());
    const baja = p.subscribeProducts(setCatalogo);
    p.loadProducts();
    return baja;
  }, [activo]);
  return IS_APP_BUILD && activo ? catalogo : null;
}
